const state = {
  isPopupActive: true,
  shouldPopupOpens: true
};

const mutations = {
  HANDLE_POPUP(state, arg) {
    state.isPopupActive = !state.isPopupActive;
    // localStorage.setItem('isPopupActive', false);
  },
  SET_SHOULD_POPUP_OPENS(state, value) {
    state.shouldPopupOpens = value
  }

};

const actions = {
  setPopup: ({ state, commit }) => {
    commit('HANDLE_POPUP');
  },
  setShouldPopupOpens: ({ state, commit }, value) => {
    commit('SET_SHOULD_POPUP_OPENS', value);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};